var buttonIcons = {
    base: {
        "--icon-margin": "7.67px",
    },
    variants: {
        position: {
            left: {
                marginRight: "var(--icon-margin)",
            },
            right: {
                marginLeft: "var(--icon-margin)",
            },
        },
        size: {
            xs: {
                "--icon-margin": "3.17px",
                fontSize: "11.67px",
            },
            sm: {
                "--icon-margin": "5.33px",
                fontSize: "13.33px",
            },
            md: {
                "--icon-margin": "7.67px",
                fontSize: "16.67px",
            },
            lg: {
                "--icon-margin": "10px",
                fontSize: "20px",
            },
            inherit: {
                fontSize: "inherit",
                lineHeight: "inherit",
            },
        },
    },
};

export { buttonIcons };
//# sourceMappingURL=button-icons.js.map
